module.exports = __webpack_public_path__ + "static/media/shipping-pulsID.d4e8bcc0.png";